import React from 'react';

import Hero from '../components/Hero/Hero';

const IndexPage = () => (
  <Hero />
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js